/**
 * Modal control abstraction.
 *
 * Provides `showModal(id)` / `hideModal(id)` so components open and close modals
 * through a project-level API instead of calling BootstrapVue's `$bvModal`
 * directly.
 *
 * Why this exists (Vue 3 forward-compatibility):
 *   `$bvModal.show(id)` / `$bvModal.hide(id)` (the global, id-addressed modal
 *   controller) does not exist in bootstrap-vue-next, where modals are driven by
 *   a `v-model` boolean instead. Routing every call site through these two
 *   methods means the Vue 3 migration reworks ONE mixin (and the per-modal
 *   v-model wiring) rather than chasing ~19 scattered `$bvModal` calls. The
 *   call sites already express intent ("show this modal") and won't need to
 *   change again.
 *
 * Behavior is identical to the previous direct calls on Vue 2.
 */
export const ModalMixin = {
  methods: {
    showModal(id) {
      this.$bvModal.show(id);
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    }
  }
};

export default ModalMixin;
